var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"sublimelight-gradient",attrs:{"to":'/exam/' + _vm.testId,"dark":"","large":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-book-open-outline")]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }